import React from 'react';
import PropTypes from 'prop-types';
import './CreateChatGroupModal.scss';

class CreateChatGroupModal extends React.Component {
    state = {
        selectedUser: null,
        isCreating: false,
        searchQuery: '',
    };

    handleUserChange = (user) => {
        this.setState({ selectedUser: user });
    };

    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    };

    handleClearSearch = () => {
        this.setState({ searchQuery: '' });
    };

    handleCreate = () => {
        const { selectedUser } = this.state;
        const { currentUserId, locationId, onClose, createChatSession, onChatCreate } = this.props;

        if (!selectedUser) return;

        this.setState({ isCreating: true });

        createChatSession(selectedUser.value, currentUserId, locationId);
        onClose();
        if (onChatCreate) {
            onChatCreate(); // 👈 Switch tab after starting chat
        }

    };

    render() {
        const { allUsers, onClose, onOpenCreateChannel, shouldDisableDm, shouldDisableGroupCreate } = this.props;
        const { selectedUser, isCreating, searchQuery } = this.state;

        const filteredUsers = allUsers.filter((user) => {
            console.log(user);
            const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
            const jobTitle = (user.position || '').toLowerCase();
            const query = searchQuery.toLowerCase();
            return fullName.includes(query) || jobTitle.includes(query);
        });

        const userOptions = filteredUsers.map((user) => ({
            value: user.owner_id,
            label: `${user.first_name} ${user.last_name}`,
            role: user.position || '',
            avatarUrl: user.profile_image_thumb_url || '/icons/default-profile-thumb.svg', // assume avatar or use fallback
        }));

        return (
            <div className="chat-modal-overlay">
                <div className="chat-modal-new">
                    <div className="chat-modal-new-header">
                        <h2>Create New Message</h2>
                        <button className="chat-modal-new-close" onClick={onClose}>×</button>
                    </div>

                    <div className="chat-modal-new-body">
                        <div className="chat-modal-new-label-row">
                            <label>Select User</label>
                            {shouldDisableGroupCreate !== 0 && (
                                <button className="create-channel-link" onClick={onOpenCreateChannel}>
                                    Create a Channel
                                </button>
                            )}
                        </div>

                        <div className="chat-modal-new-search-container">
                            <input
                                type="text"
                                className="chat-modal-new-search"
                                placeholder="Search by name or job title..."
                                value={searchQuery}
                                onChange={this.handleSearchChange}
                            />
                        </div>

                        <div className="chat-modal-new-user-list">
                            {userOptions.map((user) => (
                                <div
                                    key={user.value}
                                    className={`chat-modal-new-user-item ${selectedUser?.value === user.value ? 'selected' : ''}`}
                                    onClick={() => this.handleUserChange(user)}
                                >
                                    <img src={user.avatarUrl || '/icons/default-profile-thumb.svg'} className="avatar" />
                                    <div className="user-details">
                                        <div className="user-name">{user.label}</div>
                                        <div className="user-role">{user.role}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="chat-modal-new-footer">
                        <button className="chat-modal-new-cancel" onClick={onClose}>Cancel</button>
                        <button
                            className="chat-modal-new-create"
                            onClick={this.handleCreate}
                            disabled={!selectedUser || isCreating}
                        >
                            Start Conversation
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

CreateChatGroupModal.propTypes = {
    allUsers: PropTypes.array.isRequired,
    createChatSession: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    currentUserId: PropTypes.number.isRequired,
    onOpenCreateChannel: PropTypes.func.isRequired,
    shouldDisableDm: PropTypes.bool.isRequired,
    shouldDisableGroupCreate: PropTypes.number.isRequired,
};

export default CreateChatGroupModal;
